import { render, staticRenderFns } from "./carValuation.vue?vue&type=template&id=537174b5&scoped=true"
import script from "./carValuation.vue?vue&type=script&lang=js"
export * from "./carValuation.vue?vue&type=script&lang=js"
import style0 from "./carValuation.vue?vue&type=style&index=0&id=537174b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537174b5",
  null
  
)

export default component.exports